import { render, staticRenderFns } from "./BlockProject.vue?vue&type=template&id=6e13ff58&scoped=true&"
import script from "./BlockProject.vue?vue&type=script&lang=js&"
export * from "./BlockProject.vue?vue&type=script&lang=js&"
import style0 from "./BlockProject.vue?vue&type=style&index=0&id=6e13ff58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e13ff58",
  null
  
)

export default component.exports